import { Component, Inject, OnInit } from '@angular/core';
import { ViewOutstationComponent } from '../view-outstation/view-outstation.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { AccountService } from '../../users/data/services/account.service';
import { MatInputModule } from '@angular/material/input';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-updat-outstation',
  templateUrl: './updat-outstation.component.html',
  styleUrls: ['./updat-outstation.component.sass']
})
export class UpdatOutstationComponent implements OnInit {
  updatOutstationForm: FormGroup;
  allDetails: any;

  constructor(
    public dialogRef: MatDialogRef<ViewOutstationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private accountService: AccountService,
    private snackbar: SnackbarService) { }

  ngOnInit(): void {
    this.allDetails = this.data.test;
    console.log("data", this.allDetails);
    this.updatOutstationForm = this.createForm();
  }
  createForm(): FormGroup {
    return this.fb.group({
      outstationName: [this.allDetails.outStationName, Validators.required],
      outstationLocation: [this.allDetails.outStationLocation, Validators.required],
    });
  }
  onClick(): void {
    this.dialogRef.close();
  }
  updatOutstation() {
    if (this.updatOutstationForm.valid) {
      const updatdata = {
        id: this.allDetails.id,
        outstationLocation: this.updatOutstationForm.value.outstationLocation,
        outstationName: this.updatOutstationForm.value.outstationName
      }

      console.log("data to update",updatdata);
      this.accountService.updatOutStation(this.allDetails.id, updatdata).subscribe({
        next: ((res) => {
          if (res.statusCode === 200) {
            this.snackbar.showNotification("snackbar-success", "outstation update successfully");
          } else {
            this.snackbar.showNotification("snackbar-danger", "outstation update failed");
          }
        }),
        error: ((error) => {
          this.snackbar.showNotification("snackbar-danger", "Outstation update failed")
          console.log("Error updating", error.message);
        }),
        complete: (() => { })
      })
      this.dialogRef.close();
    }
  }



  addStationForm: any;
  submit() {
    throw new Error('Method not implemented.');
  }
}
